<div class="page-content">
    <div class="body-data">
        <div class="content ">
            <div class="row mr-0 ml-0">
                <div class="col-md-4">
                    <div class="image">
                        <img src="assets/svg/Verification Padded.svg" alt="">
                    </div>
                </div>
                <div class="col-md-8 right">
                    <div class="row mr-0 ml-0">
                        <div class="pl-0 pr-0  text-center step">
                            <img src="assets/svg/Orange with Border.svg" alt="">
                            <p class="medium mb-0  text-center mt-2">Create Account</p>
                        </div>
                        <hr class="horizontal">
                        <div class="pl-0 pr-0  text-center">
                            <img src="assets/svg/grey with border.svg" alt="">
                            <p class="medium mb-0  text-center mt-2">Get verified</p>
                        </div>
                        <hr class="horizontal">
                        <div class="pl-0 pr-0  text-center">
                            <img src="assets/svg/grey with border.svg" alt="">
                            <p class="medium mb-0  text-center mt-2">Recieve Enquiry</p>
                        </div>
                        <hr class="horizontal">
                        <div class="pl-0 pr-0  text-center">
                            <img src="assets/svg/grey with border.svg" alt="">
                            <p class="medium mb-0  text-center mt-2">Start Production</p>
                        </div>
                        <hr class="horizontal">
                        <div class="pl-0 pr-0 col-md-2 text-center">
                            <img src="assets/svg/grey with border.svg" alt="">
                            <p class="medium mb-0  text-center mt-2">Recieve Payments</p>
                        </div>
                    </div>
                    <h6 class="semi-bold verfication">Verification Pending !!</h6>
                    <div class="terms">
                        <p> 1. We Will Verify The Information And Or Documents You Have Provided While Registering In The Next 3-4 Business Days.</p>
                        <br>
                        <p> 2. If The Information You Provided Is Satisfactory, We Will Perform A Manufacturing Feasibility And Quality Audit At Your Factory/Works Address On A Mutually Agreed Date. We Will Communicate The Same Well In Advance Through Email,
                            SMS And A Call.</p>
                        <br>
                        <p> 3. Once Your Company Passes The Audit, You Are Required To Sign An NDA To Become Eligible To Start Receiving The Purchase Orders From Truventor Or It’s Customers And Gain Full Access To Truventor’s Manufacturing Partner Panel And
                            It’s Allied Products.</p>
                        <br>
                        <p> 4. For any further questions, write to us at: <span> partner@truventor.com</span></p>

                    </div>
                    <div>
                        <button [routerLink]="['/admin/dashboard']">Go To Dashboard</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>